import { apiRequest } from './api';

export const aboutService = {
  getAboutContent: () => apiRequest('/api/about'),
  getAllMilestones: () => apiRequest('/api/about/milestones')
};
